import {
  DEFAULT_ERROR,
  DEFAULT_SUCCESS,
  DEFAULT_WARNING,
  ERROR_DELETE_SCHEDULING_INSTANCE,
  ERROR_NAVIGATING_TO_INSTANCE,
  ERROR_REMOVING_USER,
  NOT_AUTHORIZED_CREATE_SCHEDULING_INSTANCE,
  NOT_AUTHORIZED_DEFAULT,
  NOT_AUTHORIZED_USER_FETCH,
  NOT_AUTHORIZED_USER_INVITE,
  NOT_AUTHORIZED_USER_VIEW,
  SUCCESS_CREATE_SCHEDULING_INSTANCE,
  SUCCESS_DELETE_SCHEDULING_INSTANCE,
  SUCCESS_INVITATION,
  SUCCESS_USER_REMOVED,
  SUCCESS_USER_UPDATE } from
'../const/messageCodes';
import { useI18n } from '../i18n';

export const useGenerateMessage = () => {
  const { t } = useI18n();

  const getErrorMessageByCode = (code: string, substitutions: Record<string, string> | null = null) => {
    const messages: Record<string, string> = {
      [DEFAULT_ERROR]: t("Something went wrong. Please refresh and try again.", substitutions, {
        project: 'enterprise-dashboard' }),

      [NOT_AUTHORIZED_DEFAULT]: t("Not authorized.", substitutions, { project: 'enterprise-dashboard' }),
      [NOT_AUTHORIZED_USER_FETCH]: t("Not authorized to fetch user", substitutions, {
        project: 'enterprise-dashboard' }),

      [NOT_AUTHORIZED_USER_VIEW]: t("Not authorized to view users", substitutions, {
        project: 'enterprise-dashboard' }),

      [NOT_AUTHORIZED_USER_INVITE]: t("Not authorized to create new org user", substitutions, {
        project: 'enterprise-dashboard' }),

      [ERROR_REMOVING_USER]: t("There was an error removing this user from the organization. Please try again",

      substitutions, {
        project: 'enterprise-dashboard' }),

      [NOT_AUTHORIZED_CREATE_SCHEDULING_INSTANCE]: t("Not authorized to create a scheduling instance", substitutions, {
        project: 'enterprise-dashboard' }),

      [ERROR_DELETE_SCHEDULING_INSTANCE]: t("There was an error attempting to delete {instanceName}", substitutions, {
        project: 'enterprise-dashboard' }),

      [ERROR_NAVIGATING_TO_INSTANCE]: t("There was an error navigating to the instance. Please try again.",

      substitutions, {
        project: 'enterprise-dashboard' })

    };

    return messages[code] ?? messages[DEFAULT_ERROR];
  };

  const getSuccessMessageByCode = (code: string, substitutions: Record<string, string> | null = null) => {
    const messages: Record<string, string> = {
      [DEFAULT_SUCCESS]: t("Success", {}, { project: 'enterprise-dashboard' }),
      [SUCCESS_INVITATION]: t("An invitation was emailed to {user}", substitutions, {
        project: 'enterprise-dashboard' }),

      [SUCCESS_USER_REMOVED]: t("User was successfully removed from the organization", substitutions, {
        project: 'enterprise-dashboard' }),

      [SUCCESS_USER_UPDATE]: t("User was successfully updated", substitutions, { project: 'enterprise-dashboard' }),
      [SUCCESS_CREATE_SCHEDULING_INSTANCE]: t("{instanceName} has been created.", substitutions, {
        project: 'enterprise-dashboard' }),

      [SUCCESS_DELETE_SCHEDULING_INSTANCE]: t("{instanceName} has been deleted.", substitutions, {
        project: 'enterprise-dashboard' })

    };
    return messages[code] ?? messages[DEFAULT_SUCCESS];
  };

  const getWarningMessageByCode = (code: string, substitutions: Record<string, string> | null = null) => {
    const messages: Record<string, string> = {
      [DEFAULT_WARNING]: t("Something went wrong. Please refresh and try again.", substitutions, {
        project: 'enterprise-dashboard' })

    };
    return messages[code] ?? messages[DEFAULT_WARNING];
  };

  return {
    getErrorMessageByCode,
    getSuccessMessageByCode,
    getWarningMessageByCode
  };
};